const deviceStorageKey = 'sgs-fee-portal:device-id'

type DeviceStorage = {
  getItem(key: string): string | null
  setItem(key: string, value: string): void
}

function createDeviceId(): string {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID()
  }
  return `device-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`
}

export function getStableDeviceId(storage?: DeviceStorage): string {
  const currentStorage = storage ?? (typeof window !== 'undefined' ? window.localStorage : undefined)
  if (!currentStorage) return 'server-device'
  const existing = currentStorage.getItem(deviceStorageKey)
  if (existing) return existing
  const next = createDeviceId()
  currentStorage.setItem(deviceStorageKey, next)
  return next
}
